<template>
  <div class="task-item-left-row">
    <div class="row-left"><b>任务类型：</b>{{ record.dn }}</div>
    <div class="row-right">
      <span v-if="record.isManual">手动创建</span><span v-else>定时任务</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "record-info",
  props: ["record"]
};
</script>

<style scoped></style>
